import React from 'react'
import styles from './Library.module.scss'
import { Tabs } from 'components'
import LibraryTab from './LibraryTab'
import ShotsTab from './ShotsTab'

const tabs = ['library', 'shots']

const Library = () => {
  const [selectedTab, setSelectedTab] = React.useState(tabs[0])

  return (
    <div className={styles.container}>
      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {
        {
          [tabs[0]]: <LibraryTab />,
          [tabs[1]]: <ShotsTab />
        }[selectedTab]
      }
    </div>
  )
}

export default Library
